module.exports = __webpack_public_path__ + "assets/img/TrendingNow_sport.0775a124-ps.jpg";